import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=4def74f1"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4def74f1')) {
      api.createRecord('4def74f1', component.options)
    } else {
      api.reload('4def74f1', component.options)
    }
    module.hot.accept("./inbox.vue?vue&type=template&id=4def74f1", function () {
      api.rerender('4def74f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/inbox.vue"
export default component.exports